import {Location} from '@angular/common';
import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {FileService} from '../../../services/file.service';
import {MessageService} from '../../../services/message.service';

@Component({
    selector: 'app-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit, AfterViewInit {
    editorStylePreview: any;
    htmlContent: string;
    messageId: number;
    isLoading: boolean;
    message: any;
    subject: string;
    imageSource: any;

    constructor(public location: Location,
                public route: ActivatedRoute,
                public fileService: FileService,
                private messageService: MessageService) {
        this.isLoading = true;
        this.subject = '';
        this.editorStylePreview = {height: '100%;', width: '100%', border: '0px'};
    }

    ngOnInit(): void {
        this.route.params.subscribe((params: any) => {
            this.messageId = +params.id;
            console.log(this.messageId);
        });
    }

    async ngAfterViewInit() {
        await this.getLogo();
        await this.initMessage();
        if (this.message.is_displayed === 0) {
            const model = {
                id: this.message.id,
                isDisplayed: this.message.is_displayed
            };
            await this.messageService.markMessageAsSeen(model);
        }
    }

    async getLogo() {
        try {
            const res = await this.fileService.downloadFile(`college/logo`);
            const reader = new FileReader();
            reader.readAsDataURL(res);
            reader.onloadend = () => {
                this.imageSource = reader.result;
            };
        } catch (e) {
            // this.toastMessagesService.toastErrorMessage(e.message);
            this.imageSource = '';
        }
    }

    async initMessage() {
        try {
            this.isLoading = true;
            this.message = await this.messageService.getMessageById(this.messageId);
            this.htmlContent = this.message.message;
            this.subject = this.message.subject;
        } catch (e) {
            console.log(e);
        } finally {
            this.isLoading = false;
        }
    }

    navigateBack() {
        this.location.back();
    }

  editorCreated($event: any, value) {
    $event.root.innerHTML = value;
  }
}
